export default __webpack_public_path__ + "static/media/covenantofpestilence.0491f3e2.png";